/**
 * Vendor names on screen — one source for the area tabs, page titles, back
 * links and the Accounts Payable navigation. Code keeps the API resource
 * names (vendors, vendor services, expenses, payments); screens use these.
 *
 * Vendor Management (the vendor directory, its area tabs):
 *   Vendor Master            → `/finance/vendor-management/vendors`
 *   Services & Subscriptions → `/finance/vendor-management/services`
 *
 * Accounts Payable (the money owed to vendors, a navigation section of its
 * own; these two registers keep their addresses):
 *   Supplier Bills           → `/finance/vendor-management/payables` (the
 *                              API's expenses: every record is a payable)
 *   Payment Register         → `/finance/vendor-management/ledger` (every
 *                              payment made against a bill — not the
 *                              double-entry general ledger)
 */
export const VENDOR_AREA = 'Vendor Management';
export const VENDOR_SECTION = {
  vendors: 'Vendor Master',
  services: 'Services & Subscriptions',
  payables: 'Supplier Bills',
  ledger: 'Payment Register',
} as const;
